import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgHomeOutline = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.60094 1.13405C7.83566 0.955317 8.16434 0.955317 8.39906 1.13405L14.2491 5.58859C14.4074 5.70916 14.5 5.89453 14.5 6.09091V13.0909C14.5 13.5972 14.2946 14.0828 13.9289 14.4408C13.5632 14.7989 13.0672 15 12.55 15H3.45C2.93283 15 2.43684 14.7989 2.07114 14.4408C1.70545 14.0828 1.5 13.5972 1.5 13.0909V6.09091C1.5 5.89453 1.59261 5.70916 1.75094 5.58859L7.60094 1.13405ZM6.7 13.7273H9.3V8.63636H6.7V13.7273ZM10.6 13.7273V8C10.6 7.64855 10.309 7.36364 9.95 7.36364H6.05C5.69101 7.36364 5.4 7.64855 5.4 8V13.7273H3.45C3.27761 13.7273 3.11228 13.6602 2.99038 13.5409C2.86848 13.4215 2.8 13.2597 2.8 13.0909V6.40214L8 2.44255L13.2 6.40214V13.0909C13.2 13.2597 13.1315 13.4215 13.0096 13.5409C12.8877 13.6602 12.7224 13.7273 12.55 13.7273H10.6Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgHomeOutline)
const IconSvgHomeOutline = createIcon(ForwardRef, 'SvgHomeOutline')
export default IconSvgHomeOutline
